<div
    class="flex max-width-container justify-center px-6 xl:px-[100px] md:px-[6.9%]"
    [class.hidden]="hideProgressBar"
    [ngClass]="{ 'pointer-events-none': isFirstTimeJourney }">
    <div
        id="resumeLearningContainer"
        class="progress-indicator-container w-full bg-white border-[1px] shadow-md border-[#F1F1F1] rounded-xl p-4">
        <div class="header flex justify-between relative">
            <h3 class="font-semibold md:text-2xl text-[#231F20] ellipsis-line-1">{{ details.programTitle }}</h3>
            <button
                type="button"
                class="absolute -right-2 -top-1 text-[#817F7F]"
                (click)="hideProgressBar = !hideProgressBar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="content flex xl:flex-row flex-col xl:items-center xl:justify-between w-full mt-2">
            <div class="progress-info w-full relative">
                <div class="relative">
                    <app-progress-bar [progress]="details.progress"></app-progress-bar>
                </div>
            </div>
            <div class="course-info xl:w-full w-full md:flex xl:my-0 my-2">
                <div class="xl:ml-6 mr-4 flex items-center">
                    <div class="inline-block bg-primary-play-box-icon flex-shrink-0 icon-[1.125rem] mr-2"></div>
                    <div class="ellipsis-line-1">
                        {{ details.lastProgramChapter }}
                    </div>
                </div>
                <div class="xl:ml-4 mr-4 flex items-center md:min-w-[11rem]">
                    <div class="inline-block bg-primary-clock-icon flex-shrink-0 icon-[1.125rem] mr-2"></div>
                    <div class="ellipsis-line-1">
                        @if (details.remainingSeconds > 60) {
                            {{ 'home.remainingTimeLeft' | translate: { duration: getRemainingTime(details.remainingSeconds) } }}
                        } @else {
                            {{ 'home.remainingTimeLeftSeconds' | translate: { duration: details.remainingSeconds } }}
                        }
                    </div>
                </div>
            </div>
            <div class="button-wrapper xl:w-fit w-full xl:flex xl:justify-end">
                <a
                    class="btn-primary xl:!px-6 xl:w-[13.125rem] w-full"
                    [routerLink]="[details.mainRoute, details.programId]"
                    [queryParams]="{ resume: details.lastProgramChapterId }">
                    <span class="inline-block bg-book-icon flex-shrink-0 icon-[1rem] mr-2"></span>
                    <span class="inline-block max-w-fit">
                        {{ 'button.resumeLearning' | translate }}
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>
